<template>
  <div>
    <div class="navigation-bar-wrapper">
      <div class="navigation-bar-container">
        <a class="logo-wrapper" href="/index" target="_blank">
          <img src="../assets/image/logo.png" alt="" srcset="" />
        </a>
        <div class="navigation-bar-menu-wrapper">
          <div
            class="menus-wrapper"
            :style="[
              {
                width: !navStatus ? '100%' : '0',
                opacity: !navStatus ? '1' : '0',
              },
            ]"
          >
            <template v-for="item in menuList">
              <router-link
                v-if="item.target === 'self'"
                :class="['menu-item']"
                :key="item.name"
                :to="item.path"
                >{{ item.name }}</router-link
              >
              <a
                class="menu-item"
                v-else-if="item.target === 'blank'"
                :href="item.path"
                target="_blank"
                :key="item.name"
                >{{ item.name }}</a
              >
            </template>
            <!-- <router-link
              :class="['menu-item']"
              v-for="item in menuList"
              :key="item.name"
              :to="item.path"
              :target="item.target"
            >
              {{ item.name }}
            </router-link> -->
          </div>
          <div class="navigation-bar-menu-tool">
            <a v-if="token" class="nav-cart nav-msg" href="/cart"
              >
              <img src="../assets/image/hn-cart-icon.png"/>
              <div v-if='user.shoppingCartCount > 0' class="cart-number">{{ user.shoppingCartCount > 99 ? '99+' : user.shoppingCartCount }}</div>
            </a>
            <router-link v-if="token" class="mail-box nav-msg" to="/user/account/mail"
              >
              <img class="mail-img" src="../assets/image/mail.png"/>
              <div v-if='user.siteCount > 0' class="mail-num">{{ user.siteCount > 99 ? '99+' : user.siteCount }}</div>
            </router-link>
            <!-- 已登录 -->
            <div class="user-info" v-if="!isHideMenu && token" @click="toUser">
              <img class="user-avatar" src="../assets/image/avatar.png" />
              <div class="u-dropdown-menu-wrapper">
                <ul class="u-dropdown-menu">
                  <li class="item item-info">
                    <img class="user-avatar" src="../assets/image/avatar.png" />
                    <div style="margin-left: 10px">
                      <div class="user-name">
                        {{ user.nick || user.mobile }}
                      </div>
                      <div class="user-id">ID：{{ user.id || "xxxx" }}</div>
                    </div>
                  </li>
                  <li class="item item-price">
                    <div class="item-price-wrapper">
                      <span class="name">余额：</span>
                      <span class="label price">{{ balance.toFixed(2) }}</span>
                    </div>
                    <router-link
                      class="recharge"
                      to="/user/finance/account/recharge"
                      >充值</router-link
                    >
                  </li>
                  <li class="logout" @click="evt_logout">安全退出</li>
                </ul>
              </div>
            </div>
            <!-- 未登录 -->
            <Button
              v-else-if="!isHideMenu"
              class="nav-login-btn"
              style="margin-left: 50px"
              type="info"
              ghost
              to="/login"
              >注册/登录</Button
            >
            <div class="tool-check" @click="onChangeNavHide">
              <img
                v-show="navStatus"
                class="nav-close"
                src="../assets/image/hn-nav-close-icon.png"
              />
              <img
                v-show="!navStatus"
                class="nav-open"
                src="../assets/image/hn-nav-open-icon.png"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="fill" class="navigation-bar-placeholder"></div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  name: "navigationBar",
  props: {
    fill: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      menuList: [
        {
          name: "域名注册",
          path: "/index",
          target: "self",
        },
        {
          name: "关于我们",
          path: "http://www.hkzhihuikang.com/case_complex.aspx?nid=4",
          target: "blank",
        },
        {
          name: "Whois查询",
          path: "/whoisSearch",
          target: "self",
        },
      ],
    };
  },
  computed: {
    ...mapState(["navStatus", "token", "user", "balance"]),
    isHideMenu() {
      return (
        this.$route.name === "login" ||
        this.$route.name === "sige" ||
        this.$route.name === "forgot"
      );
    },
  },
  methods: {
    ...mapMutations(["MUT_NAV_STATUS"]),
    ...mapMutations(["MUT_TOKEN_INFO"]),
    onChangeNavHide() {
      this.MUT_NAV_STATUS(!this.navStatus);
    },
    evt_logout() {
      this.MUT_TOKEN_INFO(null);
      window.location.reload();
      localStorage.removeItem("vuex");
    },
    toUser() {
      this.$router.push("/user");
    },
  },
};
</script>

<style lang="less" scoped>
.navigation-bar-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
  box-sizing: border-box;
  background-color: #FFFFFF;
  border-bottom: 1px solid #E9E9E9;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  .navigation-bar-container {
    width: 1200px;
    height: 100px;
    margin: 0 auto;
    .flex(space-between, center);
    .logo-wrapper {
      height: 53px;
      font-size: 0;
      img {
        width: auto;
        height: 100%;
        object-fit: cover
      }
    }
  }
  .navigation-bar-menu-wrapper {
    .flex(flex-end, center);
    .menus-wrapper {
      display: flex;
      align-items: center;
      overflow: hidden;
      opacity: 1;
      transition: all 0.3s;
      .menu-item {
        color: #333333;
        font-size: 16px;
        margin-right: 40px;
        white-space: nowrap;
        transition: color .3s;
        &:hover {
          color: #288DF0;
        }
      }
    }
    .navigation-bar-menu-tool {
      .flex(flex-end, center);
      // 导航栏「注册/登录」：实心蓝底白字（覆盖全局 ghost 外观）
      .nav-login-btn {
        &.ivu-btn {
          background-color: @brand;
          border-color: @brand;
          color: #fff;
          font-size: 14px;
          padding: 0 20px;
          height: 36px;
          line-height: 34px;
          border-radius: 18px;
        }
        &.ivu-btn:hover {
          background-color: @brand-hover;
          border-color: @brand-hover;
          color: #fff;
        }
        &.ivu-btn:active {
          background-color: @brand-deep;
          border-color: @brand-deep;
          color: #fff;
        }
      }
    }
    .nav-cart {
      display: inline-block;
      width: 25px;
      height: 25px;
      position: relative;
      img {
        width: 100%;
        height: 100%;
      }
      .cart-number{
        box-sizing: border-box;
        min-width: 18px;
        padding:0 5px;
        height: 18px;
        border-radius: 9px;
        color: #fff;
        font-size: 12px;
        background: #288DF0;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top:-8px;
        left: 20px;
      }
    }

    .mail-box{
      position: relative;
      width: 25px;
      height: 25px;
      margin-left: 20px;
      .mail-img{
        width: 26px;
        height: 26px;
      }
      .mail-num{
        box-sizing: border-box;
        min-width: 18px;
        padding:0 5px;
        height: 18px;
        border-radius: 9px;
        color: #fff;
        font-size: 12px;
        background: #288DF0;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top:-8px;
        left: 16px;
      }
    }
    .nav-cart.nav-msg,.mail-box{
      img{
        transition: opacity .3s;
      }
      &:hover img{
        opacity: .7;
      }
      &::after {
        content: "";
        display: inline-block;
        position: absolute;
        bottom: -10px;
        left: 50%;
        transform: translateX(-50%);
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: #288DF0;
      }
    }
    .user-info:hover .u-dropdown-menu-wrapper {
      display: block;
    }
    .user-info:hover .u-dropdown-menu-wrapper .u-dropdown-menu {
      height: auto;
    }
    .user-info {
      position: relative;
      padding: 30px 0;
      margin: 0 25px;
      cursor: pointer;
      &::after {
        content: "";
        position: absolute;
        bottom: 30px;
        right: -20px;
        display: inline-block;
        border: 6px solid transparent;
        border-top-color: #288DF0;
        transform: rotateZ(-45deg);
      }
      .user-avatar {
        width: 34px;
        height: 34px;
        border-radius: 50%;
      }
      .u-dropdown-menu-wrapper {
        display: none;
        width: 192px;
        position: absolute;
        top: 100%;
        right: -20px;
        z-index: 1000;
        list-style: none;
        padding-top: 20px;
        margin-top: -20px;
        background-color: transparent;
        overflow: hidden;
      }
      .u-dropdown-menu {
        height: 0;
        transition: all 0.5s ease-in-out;
        position: relative;
        border: 1px solid #E9E9E9;
        list-style: none;
        font-size: 14px;
        text-align: left;
        background-color: #FFFFFF;
        box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
        background-clip: padding-box;
        width: 100%;
        &::after {
          content: "";
          position: absolute;
          top: -20px;
          right: 20px;
          z-index: 1001;
          display: inline-block;
          border: 10px solid transparent;
          border-bottom-color: #E9E9E9;
        }
        &::before {
          content: "";
          position: absolute;
          top: -18px;
          right: 20px;
          z-index: 1002;
          display: inline-block;
          border: 10px solid transparent;
          border-bottom-color: #FFFFFF;
        }
        .item {
          padding: 22px 15px;
          .flex(center, center);
          border-bottom: 1px solid #F1F1F7;
        }
        .item-info {
          .user-name {
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            color: #333333;
            .ellipsis(125px);
          }
          .user-id {
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            color: #999999;
            .ellipsis(125px);
          }
        }
        .item-price {
          justify-content: space-between;
          .item-price-wrapper {
            .flex(flex-start, center);
            .name {
              color: #999999;
            }
            .label {
              color: #333333;
            }
            .price {
              height: 20px;
              .ellipsis(80px);
              &::before {
                content: "¥";
              }
            }
          }
          .recharge {
            line-height: 14px;
            color: #288DF0;
            border-bottom: 2px solid #288DF0;
          }
        }
        .logout {
          line-height: 44px;
          color: #333333;
          font-weight: 400;
          font-size: 16px;
          text-align: center;
        }
        // .u-label {
        //     flex: 0 0 70px;
        // }
        // .price {
        //     &::before {
        //     content: "¥";
        //     margin-right: 2px;
        //     }
        //     color: #ff5c35;
        //     text-overflow: ellipsis;
        //     overflow: hidden;
        // }
      }
      .logout {
        margin-top: 10px;
      }
    }
    .nav-close {
      width: 28px;
      height: 28px;
      cursor: pointer;
    }
    .nav-open {
      width: 36px;
      height: 26px;
      cursor: pointer;
    }
    .nav-open,
    .nav-close {
      transition: opacity .3s;
      &:hover {
        opacity: .7;
      }
    }
    .tool-check {
      .flex(center, center);
      margin-left: 10px;
      padding: 4px 6px;
      border-radius: 6px;
      transition: background-color .3s;
      &:hover {
        background-color: @brand-bg;
      }
    }
  }
}
.navigation-bar-placeholder {
  box-sizing: border-box;
  display: block;
  height: 100px;
  margin: 0;
  padding: 0;
}
.logout {
  height: 54px;
  line-height: 54px !important;
  margin-top: 0 !important;
  &:hover {
    background-color: #F2F2F2;
  }
}
</style>
